import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "crm:flex crm:flex-col 3crm:xl:flex-row crm:ml-2 3crm:xl:items-center crm:justify-start 3crm:xl:justify-between crm:w-full" }
const _hoisted_2 = { class: "crm:flex crm:flex-col 3crm:xl:flex-row crm:justify-start" }
const _hoisted_3 = { class: "crm:font-bold 3crm:xl:px-4" }
const _hoisted_4 = {
  key: 0,
  class: "crm:flex crm:mt-2 3crm:xl:mt-0"
}
const _hoisted_5 = { class: "crm:whitespace-nowrap crm:overflow-hidden crm:text-ellipsis crm:text-secondary crm:mr-2 crm:max-w-[36rem]" }

import {inject, computed} from "vue";


export default {
  __name: 'AppChecklistModelloItem',
  props: {
  /**
   * dati del modello
   */
  modello: {
    type: Object,
    default() {
      return {}
    }
  },
  /**
   * se true il modello è selezionato
   */
  selected: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

/**
 * @doc
 * Renderizza un modello di checklist precedentemente creato
 */
const props = __props

const $DesignSystem = inject('$DesignSystem')
const openDetail = inject('openDetail')

// trasforma tutte le richieste di documenti in una stringa unica da mostrare
const documentiRichiesti = computed(() => {
  if(props.modello.elements['atom_components'] !== undefined) {
    return (Object.values(props.modello.elements.atom_components.elements).reduce((result, item) => {
      return result + ', ' + item.label
    }, '')).substring(1)
  }

  return null;
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("b", _hoisted_3, _toDisplayString(__props.modello.title), 1 /* TEXT */),
      (documentiRichiesti.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(documentiRichiesti.value), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    (__props.modello.elements['atom_components'] !== undefined)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_unref(openDetail)(__props.modello)), ["prevent"])),
          class: "crm:cursor-pointer crm:text-primary! crm:underline! crm:hover:no-underline crm:mt-2 3crm:xl:mt-0"
        }, " Vedi anteprima "))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}